<template>
  <div>
    <a-drawer :title="`${actType}`" :width="720" :visible="showFolderForm" :body-style="{ paddingBottom: '80px' }"
      @close="close">

      <a-form-model ref="form" :model="model" :rules="rules">

        <template v-if="!model.action">
          <a-form-model-item label="所属主体" prop="corporation_ids">
            <a-select mode="multiple" show-search allow-clear placeholder="请选择" v-model="model.corporation_ids"
              option-filter-prop="children">
              <a-select-option :value="corporation.id" v-for="corporation in corporations" :key="corporation.id">
                {{ corporation.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item label="素材组名称" prop="name">
            <a-input v-model="model.name" />
          </a-form-model-item>
        </template>

        <a-form-model-item label="目录" v-if="treeData.length > 0">
          <a-tree-select
            :disabled='model.action?true:false'
            v-model="model.pid"
            style="width: 100%"
            placeholder="根目录"
            allow-clear
            :tree-data="treeData"
            :replace-fields="replaceFields"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          />
        </a-form-model-item>

        <a-form-model-item :label="actionName+'后名称'"  v-if="model.action && model.materials && model.materials.length>0">
          <a-input v-for="item in model.materials" v-model="item.name" :key="item.id"/>
        </a-form-model-item>

        <a-form-model-item :label="actionName+'后名称'" prop="name" v-else-if="model.action">
          <a-input v-model="model.name" />
        </a-form-model-item>

        <a-form-model-item label="选择的目录" prop="pid" v-if="model.action">
          <a-tree-select v-model="pid" style="width: 100%" placeholder="根目录" allow-clear :tree-data="treeData" 
            :replace-fields="replaceFields" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" />
        </a-form-model-item>

        <template v-if="!model.action">
          <a-form-model-item label="备注" prop="remark">
            <a-textarea v-model="model.remark" placeholder="" :auto-size="{ minRows: 3, maxRows: 5 }" />
          </a-form-model-item>
        </template>


      </a-form-model>

      <div :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }">
        <a-button @click="close" :disabled="loading" :style="{ marginRight: '8px' }">
          取消
        </a-button>
        <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
      </div>


    </a-drawer>
  </div>
</template>

<style lang="less" scoped>
@import 'CreateFolder';
</style>

<script>
import CreateFolder from './CreateFolder'

export default CreateFolder
</script>
